'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextInputIconRef = undefined;

var _isComponent = require('@brandwatch/axiom-utils/dist/isComponent');

var _isComponent2 = _interopRequireDefault(_isComponent);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Link = require('../Typography/Link');

var _Link2 = _interopRequireDefault(_Link);

var _Tooltip = require('../Tooltip/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _TooltipContent = require('../Tooltip/TooltipContent');

var _TooltipContent2 = _interopRequireDefault(_TooltipContent);

var _TooltipContext = require('../Tooltip/TooltipContext');

var _TooltipContext2 = _interopRequireDefault(_TooltipContext);

var _TooltipSource = require('../Tooltip/TooltipSource');

var _TooltipSource2 = _interopRequireDefault(_TooltipSource);

var _TooltipTarget = require('../Tooltip/TooltipTarget');

var _TooltipTarget2 = _interopRequireDefault(_TooltipTarget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextInputIconRef = exports.TextInputIconRef = 'TextInputIcon';

var TextInputIcon = function (_Component) {
  _inherits(TextInputIcon, _Component);

  function TextInputIcon() {
    _classCallCheck(this, TextInputIcon);

    return _possibleConstructorReturn(this, (TextInputIcon.__proto__ || Object.getPrototypeOf(TextInputIcon)).apply(this, arguments));
  }

  _createClass(TextInputIcon, [{
    key: 'getIcon',
    value: function getIcon(name, iconColor, tooltip) {
      return tooltip ? _react2.default.createElement(
        _Tooltip2.default,
        { isVisible: true },
        _react2.default.createElement(
          _TooltipTarget2.default,
          null,
          _react2.default.createElement(_Icon2.default, { name: name, size: '1rem', textColor: iconColor })
        ),
        _react2.default.createElement(
          _TooltipSource2.default,
          { width: 'auto' },
          (0, _isComponent2.default)(tooltip, _TooltipContext.TooltipContextRef) ? tooltip : _react2.default.createElement(
            _TooltipContext2.default,
            null,
            _react2.default.createElement(
              _TooltipContent2.default,
              { size: 'tiny' },
              tooltip
            )
          )
        )
      ) : _react2.default.createElement(_Icon2.default, { name: name, size: '1rem', textColor: iconColor });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          align = _props.align,
          iconColor = _props.iconColor,
          name = _props.name,
          onClick = _props.onClick,
          tooltip = _props.tooltip,
          rest = _objectWithoutProperties(_props, ['align', 'iconColor', 'name', 'onClick', 'tooltip']);

      var className = (0, _classnames3.default)('ax-input__icon', _defineProperty({}, 'ax-input__icon--align-' + align, align));

      return _react2.default.createElement(
        'span',
        { className: className },
        onClick ? _react2.default.createElement(
          _Link2.default,
          _extends({}, rest, { onClick: onClick, style: 'subtle' }),
          this.getIcon(name, iconColor, tooltip)
        ) : this.getIcon(name, iconColor, tooltip)
      );
    }
  }]);

  return TextInputIcon;
}(_react.Component);

TextInputIcon.propTypes = {
  /** Alignment inside the input field */
  align: _propTypes2.default.oneOf(['left', 'right']),
  /** Color of the TextInputIcon. */
  iconColor: _propTypes2.default.string,
  /** Name of the icon. See <Icon>. */
  name: _propTypes2.default.string.isRequired,
  /** Click handler, applies styling to indicate it is clickable. */
  onClick: _propTypes2.default.func,
  /** Optional tooltip for the icon. */
  tooltip: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element])
};
TextInputIcon.defaultProps = {
  align: 'right'
};
TextInputIcon.typeRef = TextInputIconRef;
exports.default = TextInputIcon;